import { QueryLevel } from "csi/view/_query/Level";
import declare from "dojo/_base/declare";
import AggregateFromBaseProductTableMixin from "./AggregateFromBaseProductTableMixin";

const FOOD_SUBTYPE = "FoodSubtype";
const SUBTYPE = "Subtype";

const AggregateFromFoodTable = declare(AggregateFromBaseProductTableMixin, {

	/**
	 * @override
	 * Add filter for selected FormulatedMaterial Type
	 */
	onCreateMainQueryLevel(ql: QueryLevel): void {
		this.modifyQuery(FOOD_SUBTYPE, SUBTYPE, ql);
	},
});

export = AggregateFromFoodTable;